import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/youcam-tutorial"
    exact
    path="/business/products/youcam-tutorial"
    component={AsyncPage}
  />,
];
